export const BULK_EDIT_FAILURE_IPH_ARTICLE_ID = '62h4g5fA9BUhungZSSNyEl';
